var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.QAsp_gzhz),
      expression: "QAsp_gzhz"
    }]
  }, [_c('div', {
    staticStyle: {
      "font-size": "20px",
      "float": "left",
      "margin": "-40px 0 0 40px",
      "font-weight": "600"
    }
  }, [_vm._v("OA审批-" + _vm._s(_vm.examine_name))]), _vm._v(" "), _c('el-button', {
    staticStyle: {
      "float": "right",
      "height": "40px",
      "margin-top": "-40px",
      "margin-right": "40px",
      "background-color": "#006E4B",
      "color": "#FFFFFF",
      "border": "1px solid #006E4B"
    },
    on: {
      "click": _vm.Return
    }
  }, [_vm._v("返回")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "height": "750px",
      "background-color": "white",
      "margin": "75px 40px 0 40px",
      "overflow-x": "hidden"
    }
  }, [_c('el-row', {
    staticStyle: {
      "margin": "0px"
    }
  }, [_c('el-row', [_c('el-table', {
    ref: "table",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "header-cell-style": {
        background: '#d3eae2',
        color: '#000000'
      },
      "border": true,
      "row-class-name": _vm.tableRowClassName,
      "data": _vm.tableData,
      "height": "650",
      "summary-method": _vm.getSummaries,
      "tooltip-effect": "dark"
    },
    on: {
      "selection-change": _vm.handleSelectionChange
    }
  }, [_c('el-table-column', {
    attrs: {
      "type": "selection",
      "align": "center",
      "width": "55"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "align": "center",
      "label": "序号",
      "width": "50"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope_1) {
        return [_vm._v(_vm._s(scope_1.$index + 1))]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "organize_name",
      "align": "center",
      "label": "项目名称",
      "width": "200"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "align": "center",
      "label": "收入"
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "invoiced_amount",
      "align": "center",
      "label": "开发票金额",
      "width": "120"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "align": "center",
      "label": "开票明细"
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "wage_quota",
      "align": "center",
      "label": "工资定额",
      "width": "100"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "contract_amount",
      "align": "center",
      "label": "合同金额",
      "width": "100"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "quota_proportion",
      "align": "center",
      "label": "定额占比",
      "width": "100"
    }
  })], 1)], 1), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "align": "center",
      "label": "工资明细"
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "number_of_investors",
      "align": "center",
      "label": "开资人数",
      "width": "120"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "payroll_payable",
      "align": "center",
      "label": "开资表应发工资",
      "width": "120"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "personal_part_of_social_security",
      "align": "center",
      "label": "社保个人部分",
      "width": "120"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "accumulation_fund_deduction",
      "align": "center",
      "label": "公积金扣款",
      "width": "120"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "accident_insurance_deduction",
      "align": "center",
      "label": "意外保险扣款",
      "width": "120"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "clothing_deposit",
      "align": "center",
      "label": "服装押金",
      "width": "120"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "payroll_actual_salary",
      "align": "center",
      "label": "工资表实发工资",
      "width": "120"
    }
  })], 1), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "proportion_wages",
      "align": "center",
      "label": "工资占比"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "remarks",
      "align": "center",
      "label": "备注",
      "width": "200"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "align": "center",
      "label": "操作",
      "width": "80"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', {
          staticStyle: {
            "color": "#01714d"
          },
          on: {
            "click": function($event) {
              return _vm.goZhanBi(scope.row)
            }
          }
        }, [_vm._v("详情")])]
      }
    }])
  })], 1)], 1)], 1), _vm._v(" "), _c('el-row', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.is_reviewer_state == 0),
      expression: "is_reviewer_state == 0"
    }]
  }, [_c('el-col', {
    staticStyle: {
      "margin": "50px 500px"
    }
  }, [_c('el-button', {
    attrs: {
      "type": "goon"
    },
    on: {
      "click": function($event) {
        return _vm.$refs['examine'].save(_vm.id, 1)
      }
    }
  }, [_vm._v("同意")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "addbtn"
    },
    on: {
      "click": function($event) {
        return _vm.$refs['examine'].reject(_vm.id)
      }
    }
  }, [_vm._v("驳回")])], 1)], 1), _vm._v(" "), _c('el-row', {
    staticStyle: {
      "display": "flex",
      "justify-content": "flex-start",
      "flex-wrap": "wrap",
      "margin": "0 20px"
    }
  }, _vm._l((_vm.infor), function(item, index) {
    return _c('div', {
      staticStyle: {
        "flex": "1",
        "width": "calc((100% - 20px) / 6)",
        "min-width": "calc((100% - 20px) / 6)",
        "max-width": "calc((100% - 20px) / 6)"
      }
    }, [_c('div', {
      staticStyle: {
        "margin": "20px 0",
        "font-size": "18px"
      }
    }, [_vm._v(_vm._s(item.role_name) + " : " + _vm._s(item.staff_name))])])
  }), 0)], 1)], 1), _vm._v(" "), _c('examine', {
    ref: "examine",
    attrs: {
      "spare": _vm.spare,
      "id": _vm.id
    }
  }), _vm._v(" "), _c('gzzb', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.gzzb),
      expression: "gzzb"
    }],
    ref: "gzzb",
    attrs: {
      "gzzbList": _vm.gzzbList,
      "inforchild": _vm.inforchild,
      "organize_name": _vm.organize_name
    }
  })], 1)
}
var staticRenderFns = []
export default { render: render, staticRenderFns: staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-8602f1b0","transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/jcrsgl/QAsp/QAsp_gzhz.vue
// module id = null
// module chunks = 